import axios from 'axios';

const baseURL = process.env.NODE_ENV === "production" ? "/api/cinematography/v1/photos" : "http://localhost:3001/api/cinematography/v1/photos";

export default axios.create({ baseURL });
